import React, { useState, useEffect } from 'react'
import { commerce } from './lib/commerce'
// import Products from './components/Products/Products';
// import Navbar from './components/Navbar/Navbar'
import { Products, Navbar, Cart, Checkout } from './components';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Footer from './components/Footer';
import MySmallNavBar from './components/SmallNavBar';

const App = () => {
    const [products, setProduct] = useState([]);
    const [cart, setCart] = useState({});
    const [order, setOrder] = useState({});
    const [state, setState] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    // const history = useHistory();

    const fetchProducts = async () => {
        const { data } = await commerce.products.list();
        setProduct(data);
    }

    const fetchProduct = async (name) => {
        const { data } = await commerce.products.list({
            query: name
        });
        setProduct(data);
    }

    const fetchCart = async () => {
        setCart(await commerce.cart.retrieve());
    }

    const addProductToCart = async (productId, quantity) => {
        const item = await commerce.cart.add(productId, quantity);
        setCart(item.cart);
    }

    const emptyCart = async () => {
        await commerce.cart.empty();
        setCart([]);
    }

    const incDecRemove = async (type, productId, quantity = 1) => {
        const decOrInc = type === "inc" ? 1 : type === "dec" ? - 1 : 0;
        if (decOrInc) {
            const { cart } = await commerce.cart.update(productId, { quantity: quantity + decOrInc });
            setCart(cart)
        } else if (type === "remove") {
            const { cart } = await commerce.cart.remove(productId);
            setCart(cart)
        }
    }

    const refreshCart = async () => {
        const newCart = await commerce.cart.refresh();

        setCart(newCart);
    }

    const handleCaptureCheckout = async (checkoutTokenId, newOrder) => {
        try {
            const incomingOrder = await commerce.checkout.capture(checkoutTokenId, newOrder);
            setOrder(incomingOrder);
            refreshCart();
        } catch (error) {
            // console.log(error);
            setErrorMessage(error.data.error.message);
        }
    }

    useEffect(async () => {
        setLoading(true)
        if (!state) {
            await fetchProducts();
        } else {
            await fetchProduct(state);
        }
        await fetchCart();
        setLoading(false);
    }, [state]);



    return (
        <Router>
            <div>
                <Navbar totalProducts={cart.total_items} fetchProduct={setState} />
                <Switch>
                    <Route exact path="/">
                        <Products
                            products={products}
                            handleAdd={addProductToCart}
                            loading={loading}
                            setState={setState}
                            state={state}
                        />
                    </Route>

                    <Route
                        exact
                        path="/search/:name"
                        children={<Products
                            products={products}
                            handleAdd={addProductToCart}
                            loading={loading} />}
                    />

                    <Route exact path="/cart">
                        <Cart cart={cart}
                            emptyCart={emptyCart}
                            incDecRemove={incDecRemove}
                            loading={loading}
                        />
                    </Route>

                    <Route exact path="/checkout">
                        <Checkout
                            cart={cart}
                            order={order}
                            onCaptureCheckout={handleCaptureCheckout}
                            error={errorMessage}
                        />
                    </Route>
                </Switch>

                <MySmallNavBar totalProducts={cart.total_items} />
                <Footer />
            </div>
        </Router>
    )
}

export default App
